import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography/Typography';
import { ErrorsImportToolbarInfo } from './ErrorsImportToolbarInfo';

type possibleIdColumnsValues =  'line' | 'poiName' | 'voucherName' | 'errorDescription'



export type KeyPrefixValues = typeof keyPrefixValues[keyof typeof keyPrefixValues];

interface Column {
  id: possibleIdColumnsValues;
  label: string;
  minWidth?: number;
}

export const keyPrefixValues = {
  POI: 'poi',
  VOUCHER: 'voucher'
} as const;



export default function ImportFromFileErrorsTable({data,keyPrefix}:{data:any,keyPrefix:KeyPrefixValues}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const {t} = useTranslation(['salesmarketing'], {keyPrefix});

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const columns: readonly Column[] = [
    { id: 'line', label: t(`${keyPrefix === keyPrefixValues.POI ? 'importPoiErrorsTableColumns.line': 'importVoucherErrorsTableColumns.line'}`) },
    { id: `${keyPrefix === 'poi' ? 'poiName' : 'voucherName'}`, label:t(`${keyPrefix === keyPrefixValues.POI ? 'importPoiErrorsTableColumns.poiName': 'importVoucherErrorsTableColumns.voucherName'}`) },
    { id: 'errorDescription', label:t(`${keyPrefix === keyPrefixValues.POI ? 'importPoiErrorsTableColumns.errorDescription': 'importVoucherErrorsTableColumns.errorDescription'}`)}
  ];

  const generateInsertedRowsNumber = (keyPrefix:KeyPrefixValues) =>{
    if(keyPrefix === 'poi') {
      return data.numberOfInsertedPoi + data.numberOfErrorInPoiInsert
    }
    return data.numberOfInsertedVoucher + data.numberOfErrorInVoucherInsert
  }

  const getNumberOfErrorRows = (keyPrefix:KeyPrefixValues) =>{
    if(keyPrefix === 'poi') {
      return data.numberOfErrorInPoiInsert
    }
    return data.numberOfErrorInVoucherInsert
  }

  const getNumberOfSuccessRows = (keyPrefix:KeyPrefixValues) => {
    if(keyPrefix === 'poi') {
      return data.numberOfInsertedPoi 
    }
    return data.numberOfInsertedVoucher 
        
  }
  
  return (
    <>
    <ErrorsImportToolbarInfo keyPrefix={keyPrefix} numberOfTotalRows={generateInsertedRowsNumber(keyPrefix)} numberOfErrorRowsInsert={getNumberOfErrorRows(keyPrefix)} numberOfSuccessRowInsert={getNumberOfSuccessRows(keyPrefix)} />
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{ minWidth: column.minWidth }}
                >
                 <Typography  fontWeight='bold' variant='bodySmall' >{column.label}</Typography> 
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.excelErrorRecordList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row:any) => {
                console.log({row})
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      let value = row[column.id];
                      if(column.id === 'errorDescription'){
                        value = t(`importErrors.${row.errorCode}`)
                      }
                      return (
                        <TableCell key={column.id}>
                          {value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={data.excelErrorRecordList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
    
  );
}